import React from 'react';
import { Animated } from 'react-native';
import { useTheme } from 'react-native-paper';
import { t } from '@lingui/macro';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { useNavigation } from '@react-navigation/native';

import { i18n } from '@src/i18n';

import BusinessesScreen from './Businesses';
import HashtagScreen from './Hashtag';
import PeopleScreen from './People';
import { Props, TabParamList } from './types';

const Tab = createMaterialTopTabNavigator<TabParamList>();

const Screen: React.FC<Props> = () => {
  const theme = useTheme();
  const scrollY = React.useRef(new Animated.Value(0)).current;
  const navigation = useNavigation();
  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerStyle: {
        borderBottomWidth: 0,
        elevation: scrollY.interpolate({
          inputRange: [0, 1],
          outputRange: [0, 8],
          extrapolate: 'clamp',
        }),
        shadowColor: theme.colors.disabled,
        shadowOffset: {
          height: scrollY.interpolate({
            inputRange: [0, 1],
            outputRange: [-8, 8],
            extrapolate: 'clamp',
          }),
          width: 8,
        },
        shadowRadius: scrollY.interpolate({
          inputRange: [0, 1],
          outputRange: [0, 3],
          extrapolate: 'clamp',
        }),
        shadowOpacity: 0.44,
      },
    });
  }, [navigation, scrollY, theme.colors.disabled]);

  return (
    <Tab.Navigator
      backBehavior="none"
      tabBarOptions={{
        labelStyle: {
          fontFamily: theme.fonts.regular.fontFamily,
        },
        activeTintColor: theme.colors.primary,
        inactiveTintColor: theme.colors.disabled,
      }}
    >
      <Tab.Screen
        name="Places"
        options={{
          title: `${i18n._(t`Places`)} - ${i18n._(t`Youtopin`)}`,
          tabBarLabel: i18n._(t`Places`),
        }}
        component={BusinessesScreen}
      />
      <Tab.Screen
        name="People"
        options={{
          title: `${i18n._(t`People`)} - ${i18n._(t`Youtopin`)}`,
          tabBarLabel: i18n._(t`People`),
        }}
        component={PeopleScreen}
      />
      <Tab.Screen
        name="Hashtags"
        options={{
          title: `${i18n._(t`Hashtags`)} - ${i18n._(t`Youtopin`)}`,
          tabBarLabel: i18n._(t`Hashtags`),
        }}
        component={HashtagScreen}
      />
    </Tab.Navigator>
  );
};

Screen.displayName = 'Search';

export default Screen;
